import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteRechnungCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteRechnungCommandService],
  exports: []
})
export class DeleteRechnungCommandServiceModule { }
